import React from 'react';
import {
    useEditController,
    useTranslate,
    SimpleForm,
    ReferenceField,
    TextField,
    NumberInput,
    DateField
} from 'react-admin';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

import CustomImageField from '../invoices/CustomImageField';

const useStyles = makeStyles(theme => ({
    root: {
        paddingTop: 40,
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        margin: '1em',
    },
    form: {
        [theme.breakpoints.up('xs')]: {
            width: 400,
        },
        [theme.breakpoints.down('xs')]: {
            width: '100vw',
            marginTop: -30,
        },
    },
    inlineField: {
        display: 'inline-block',
        width: '50%',
    },
    a: {
        textDecoration: 'none'
    }
}));

const OfferEdit = ({ onCancel, ...props }) => {
    const classes = useStyles();
    const controllerProps = useEditController(props);
    const translate = useTranslate();

    if (!controllerProps.record) {
        return <></>;
    }

    return (
        <div className={classes.root}>
            <div className={classes.title}>
                <Typography variant="h6">
                    {translate('resources.invoices.detail')}
                </Typography>
                <IconButton onClick={onCancel}>
                    <CloseIcon />
                </IconButton>
            </div>
            <SimpleForm
                className={classes.form}
                basePath={controllerProps.basePath}
                record={controllerProps.record}
                save={controllerProps.save}
                version={controllerProps.version}
                redirect="list"
                resource="offers"
            >
                <DateField source="createdAt" locales="es-ES" />
                <ReferenceField label="resources.budgets.fields.user" source="user._id" reference="users">
                    <TextField source="name" />
                </ReferenceField>
                <ReferenceField label="resources.suppliers.fields.supplier" source="supplier._id" reference="suppliers">
                    <TextField source="business" />
                </ReferenceField>

                <NumberInput source="amount" />
                <CustomImageField source="file" />
            </SimpleForm>
        </div>
    );
};

export default OfferEdit;
